export const data={
    projects:[{
        title:"CV Colander",
        description:"The aim of this project is to help the placement groupsand professional by automating the time-consuming task by sorting the resumes domain wise for easy screening of the candidates suited."


    },
    {
        title:"Department Webpage",
        description:"A webpage of CSIT department displaying all the information related to department along with subscription form (using HTML, CSS, JavaScript)"


    }

],
Academic:[
    {
        title:"Bachelor in Technology in Computer Science and Information Technology",
        school:"Acropolis Institute of technology and Research, Indore (M.P)",
        perc:" 8.66 CGPA"
    },
    {
        title:"Higher Secondary (12th CBSE)",
        school:"B M Convent Hr. Sec. School, Ganj Basoda, Vidisha (M.P)",
        perc:" 94.8 %"
    },
    {
        title:"Senior Secondary (10th CBSE",
        school:"Scholars Public Hr. Sec. School, Ganj Basoda, Vidisha (M.P)",
        perc:"88%"
    }
]
}